var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.667 42H70.667V34C70.667 31.5999 69.0671 30 66.667 30H54.667V26L70.667 20L54.667 14C54.667 11.5999 53.0671 10 50.667 10C48.2668 10 46.667 11.5999 46.667 14V30H34.667C32.2668 30 30.667 31.5999 30.667 34V42H14.667C12.2668 42 10.667 43.5999 10.667 46V90H42.667V74C42.667 71.5999 44.2668 70 46.667 70H54.667C57.0671 70 58.667 71.5999 58.667 74V90H90.667V46C90.667 43.5999 89.0671 42 86.667 42ZM26.667 82H18.667V74H26.667V82ZM26.667 66H18.667V58H26.667V66ZM50.667 54C46.2668 54 42.667 50.4001 42.667 46C42.667 41.5999 46.2668 38 50.667 38C55.0671 38 58.667 41.5999 58.667 46C58.667 50.4001 55.0671 54 50.667 54ZM82.667 82H74.667V74H82.667V82ZM82.667 66H74.667V58H82.667V66Z",
    fill: "#4CC89B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoards);
export default __webpack_public_path__ + "static/media/boards.8e3ff9f788b48b8b9dda26f2f7eed90b.svg";
export { ForwardRef as ReactComponent };